const validators = {
  en: {
    mixed: {
      obligatory: "Obligatory",
      default: "is invalid",
      required: "field required",
      oneOf: "must be one of the following values: {values}",
      notOneOf: "cannot be one of the following values: {values}"
    },
    string: {
      length:
        "must have exactly {length} character | must have exactly {length} characters",
      min: "must have at least {min} character | must have at least {min} characters",
      max: "must have at most {max} character | must have at most {max} characters",
      email: "value is not a valid email address",
      url: "must have a valid URL format",
      trim: "must not contain spaces at the beginning or end.",
      lowercase: "must be capitalized",
      uppercase: "must be in lowercase",
      strongPassword:
        "The passwords need to be 8 digits long and contain at least a number, a upper case letter, a lower case letter and a special character"
    },
    number: {
      min: "must be at least {min}",
      max: "should be at most {max}",
      lessThan: "must be smaller than {less}",
      moreThan: "must be greater than {more}",
      positive: "must be a positive number",
      negative: "must be a negative number",
      integer: "must be an integer"
    },
    date: {
      min: "must be greater than the date {min}",
      max: "must be less than the date {max}"
    },
    array: {
      min: "must have at least {min} item | must have at least {min} items",
      max: "should be at most {max} item | should be at most {max} items"
    }
  },
  pt: {
    mixed: {
      obligatory: "Obrigatório",
      default: "é inválido",
      required: "é um campo obrigatório",
      oneOf: "deve ser um dos seguintes valores: {values}",
      notOneOf: "não pode ser um dos seguintes valores: {values}"
    },
    string: {
      length:
        "deve ter exatamente {length} caractere | deve ter exatamente {length} caracteres",
      min: "deve ter pelo menos {min} caractere | deve ter pelo menos {min} caracteres",
      max: "deve ter no máximo {max} caractere | deve ter no máximo {max} caracteres",
      email: "valor não é um endereço de e-mail válido",
      url: "deve ter um formato de URL válida",
      trim: "não deve conter espaços no início ou no fim.",
      lowercase: "deve estar em maiúsculo",
      uppercase: "deve estar em minúsculo",
      strongPassword:
        "A senha deve conter pelo menos 8 digitos, uma letra maiuscula, uma letra minuscula, um número e um caractere especial"
    },
    number: {
      min: "deve ser no mínimo {min}",
      max: "deve ser no máximo {max}",
      lessThan: "deve ser menor que {less}",
      moreThan: "deve ser maior que {more}",
      positive: "deve ser um número posítivo",
      negative: "deve ser um número negativo",
      integer: "deve ser um número inteiro"
    },
    date: {
      min: "deve ser maior que a data {min}",
      max: "deve ser menor que a data {max}"
    },
    array: {
      min: "deve ter no mínimo {min} item | deve ter no mínimo {min} itens",
      max: "deve ter no máximo {max} item | deve ter no máximo {max} itens"
    }
  },
  es: {
    mixed: {
      obligatory: "obligatorio",
      default: "is invalid",
      required: "es un campo obligatorio",
      oneOf: "debe ser uno de los siguientes valores {values}",
      notOneOf: "no puede ser uno de los siguientes valores: {values}"
    },
    string: {
      length:
        "debe tener exactamente {length} caracter | debe tener exactamente {length} caracteres",
      min: "debe tener al menos {min} caracter | debe tener al menos {min} caracteres",
      max: "debe tener como máximo {max} caracter | debe tener como máximo {max} caracteres",
      email: "el valor no es una dirección de correo electrónico válida",
      url: "debe tener un formato de URL válido",
      trim: "no debe contener espacios al principio ni al final.",
      lowercase: "debe estar en mayúsculas",
      uppercase: "debe estar en minúsculas",
      strongPassword:
        "Las contraseñas deben tener 8 dígitos y contener al menos un número, una letra mayúscula, una letra minúscula y un carácter especial."
    },
    number: {
      min: "debe ser como mínimo {min}",
      max: "debe ser como máximo {max}",
      lessThan: "debe ser menor que {min}",
      moreThan: "debe ser mayor que {max}",
      positive: "debe ser un número positivo",
      negative: "debe ser un número negativo",
      integer: "debe ser un número entero"
    },
    date: {
      min: "debe ser mayor que la fecha {min}",
      max: "debe ser menor que la fecha {max}"
    },
    array: {
      min: "debe tener como mínimo {min} elemento | debe tener como mínimo {min} elementos",
      max: "debe tener como máximo {max} elemento | debe tener como máximo {max} elementos"
    }
  }
}

export default validators
